import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';
@Injectable({
  providedIn: 'root',
})
export class AccountService {

  constructor(
    private http: HttpClient
  ) { }

  userProfile(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/account/user-details');
  }

  changePassword(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v1/change-password', JSON.stringify(item));
  }

  upgradeAccount(item): Observable<any> {
    return this.http
      .post(environment.apiUrl + '/v1/kyc', item, { context: new HttpContext().set(BEARER_ONLY, true) });
  }

  transactions(page = 1, pageSize = 10): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl +  `/v2/transactions/lists?page=${page}&pageSize=${pageSize}`);
  }

  completeProfile(payload): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/account/white-label-complete-profile', payload, { context: new HttpContext().set(BEARER_ONLY, true) });
  }

  editProfile(payload): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/account/white-label-update-profile', payload, { context: new HttpContext().set(BEARER_ONLY, true) });
  }

  getUploadURL(type) {
    const postData = {
      extensionName: type,
      mimeType: type
    };
    return this.http
      .post<any>(environment.apiUrl + '/api/user/photo/upload2', postData, { context: new HttpContext().set(BEARER_ONLY, true) });
  }

  uploadToS3(data) {
    return this.http.put<any>(data.url, data.blob, { context: new HttpContext().set(BYPASS_HEAD, true) });
  }

  userTokens(): Observable<any> {
    return this.http
    .get<UserProfile>(environment.apiUrl + '/v2/tokens/user-token', { context: new HttpContext().set(BEARER_ONLY, true) });
  }

  scanQr(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/qrcode/scan', JSON.stringify(item));
  }

  sendPoints(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/points/send', JSON.stringify(item));
  }

  deleteAccount(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/account/request-deletion', JSON.stringify(item));
  }

}
